/**
 * Base RU dictionary. Keep keys grouped by feature; UI components reference
 * keys via `t('group.key')`. Only commonly reused strings live here — long
 * page-specific copy can stay inline.
 */
export const ru = {
  common: {
    save: 'Сохранить',
    saved: 'Сохранено',
    cancel: 'Отмена',
    delete: 'Удалить',
    confirm: 'OK',
    edit: 'Редактировать',
    create: 'Создать',
    add: 'Добавить',
    loading: 'Загрузка…',
    error: 'Ошибка',
    yes: 'Да',
    no: 'Нет',
    today: 'Сегодня',
    yesterday: 'Вчера',
    tomorrow: 'Завтра',
    back: 'Назад',
    close: 'Закрыть',
    apply: 'Применить',
    export: 'Экспорт',
  },
  nav: {
    dashboard: 'Главная',
    calendar: 'Календарь',
    clients: 'Клиенты',
    stats: 'Статистика',
    settings: 'Настройки',
  },
  appointment: {
    new: 'Новая запись',
    edit: 'Редактирование',
    reschedule: 'Перенос записи',
    start: 'Начать',
    finish: 'Завершить',
    cancel: 'Отменить запись',
    delete: 'Удалить запись',
    paid: 'Оплачено',
    debt: 'Долг',
    duration: 'Длительность',
    extend: 'Продлить',
    statusPlanned: 'Запланировано',
    statusInProgress: 'В работе',
    statusCompleted: 'Завершено',
    statusCancelled: 'Отменено',
  },
  client: {
    new: 'Новый клиент',
    name: 'Имя',
    phone: 'Телефон',
    telegram: 'Telegram',
    birthday: 'День рождения',
    source: 'Источник',
    hairType: 'Тип волос',
    note: 'Заметка',
    history: 'История',
    photos: 'Фото',
    finance: 'Финансы',
    visits: 'Визитов',
    avgCheck: 'Средний чек',
  },
  stock: {
    title: 'Склад волос',
    lots: 'Партий',
    grams: 'Всего грамм',
    movement: 'Движение',
    inflow: 'Приход',
    outflow: 'Расход',
    adjust: 'Корректировка',
    writeoff: 'Списать материалы',
    photo: 'Фото партии',
    pricePerSlice: 'Цена за срез (₽)',
    weightGrams: 'Граммовка (г)',
    editLot: 'Редактировать партию',
    newLot: 'Новая партия',
    perSlice: 'срез',
  },
  expenses: {
    title: 'Расходы',
    amount: 'Сумма',
    category: 'Категория',
    receipt: 'Чек',
  },
  otherIncomes: {
    title: 'Прочие доходы',
    name: 'Наименование',
    amount: 'Сумма',
    date: 'Дата продажи',
  },
  settings: {
    profile: 'Профиль',
    workingHours: 'Рабочие часы',
    masters: 'Работники',
    services: 'Услуги',
    extras: 'Доп. услуги',
    lengths: 'Длины волос',
    tags: 'Теги клиентов',
    expenseCategories: 'Категории расходов',
    notifications: 'Уведомления',
    backup: 'Бэкап',
  },
  weekdays: {
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    sat: 'Сб',
    sun: 'Вс',
  },
};
